import React from 'react';
import AmbitiInterventoPageTemplate from '../../components/template-ambiti-di-intervento';
import { getProp, getPropMarked, getPropRel } from '../utils';

const AmbitiInterventoPagePreview = (props) => {
  const title = getProp(props, 'title');
  const intro = getPropMarked(props, 'intro');
  const titleDisturbi = getProp(props, 'titleDisturbi');
  const disturbi = getPropRel(props, 'disturbi', 'disturbo');
  const data = { title, intro, titleDisturbi, disturbi };

  return <AmbitiInterventoPageTemplate {...data} />;
};

export default AmbitiInterventoPagePreview;
